"use strict";

import angular from "angular";

angular.module("nucont.accounting.company.dataManagement", ["nucont.shared"]);
require("./data-management.routes");
